import * as React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { Link } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import "./TopBarNotConnected.scss";

const TopBarNotConnected = (props) => {
  const { title, description, colWidth, backTo, url } = props;
  return (
    <div className="topBarNotConnected">
      <Row>
        <Col md={colWidth}>
          <div className="wrapTopBarNotConnected">
            {backTo ? (
              <Link to={url} className="link-back">
                <RiArrowLeftLine />
              </Link>
            ) : (
              ""
            )}
            <div className="title-topBarNot">{title}</div>
            <div className="description-topBarNot">{description}</div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TopBarNotConnected;
